import React, { Component, PropTypes } from 'react'

/* Styles */
import './search-input.css'

/* Utilities */
import _ from 'lodash'

import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'

/* Single Playlist List Item */
export default class SearchInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: props.value,
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.value === nextProps.value) return
        this.setState({ value: nextProps.value })
    }

    getClassName() {
        const {
            className
        } = this.props
        let classNameArr = (className || "").split(' ')
        classNameArr.push('search-input', 'widget')
        return classNameArr.join(' ')
    }

    renderResetButton() {
        const {
            value,
            onReset
        } = this.props
        if (value && onReset) {
            return (
                <button
                    tabIndex="-1"
                    onClick={ onReset }
                >
                    <Icon icon={ ICON.DELETETEXT } size={ 24 }/>
                </button>
            )
        }
    }

    renderToolbar() {
        return (
            <span className="toolbar">
                { this.renderResetButton() }
            </span>
        )
    }

    onLiveChange(e) {
        this.setState({value: e.target.value})
        if (!this.debouncedOnChange) this.debouncedOnChange = _.debounce(this.onChange, 250 )
        this.debouncedOnChange()
    }

    onChange() {
      if(this.props.onChange) this.props.onChange(this.state.value)
    }

    render() {
        const {
            title,
            placeholder,
            onChange
        } = this.props
        const {
            value
        } = this.state
        return (
            <span
                className={ this.getClassName() }
            >
                <input
                    type="text"
                    title={ title }
                    value={ value }
                    placeholder={ placeholder }
                    onChange={ (e) => { this.onLiveChange(e) } }
                    onDragOver={ (e) => { e.preventDefault() }}
                    onDragEnter={ (e) => { e.preventDefault() }}
                    onDragLeave={ (e) => { e.preventDefault() }}
                    onDrop={ (e) => { e.preventDefault() }}
                />
                { this.renderToolbar() }
            </span>
        )
    }
}

SearchInput.propTypes = {
    placeholder: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    onReset: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/app/widget/search-input/index.jsx